// External libraries
import React from 'react';

// Internal modules
import { features } from '@/lib';
import { ForcedGuest, ForcedSignup, OptionalSignup, POMA } from './flows';

export const FlowTypes = (): JSX.Element => {
  // POMA
  const isPomaButtonFlow = features.isActive('isPOMAEligible');

  if (isPomaButtonFlow) {
    return <POMA />;
  }

  const isForcedGuest = features.someActive(
    'isWpsGuestUpgradeEligible',
    'isForcedGuest',
  );

  if (isForcedGuest) {
    return <ForcedGuest />;
  }

  const isOptionalSignupFlow = features.isActive('isOptionalSignup');

  if (isOptionalSignupFlow) {
    return <OptionalSignup />;
  }

  return <ForcedSignup />;
};
